import type { HelpFile } from '../../types/help'
import { CreateFunctionGroupTestIds } from '../../../testids/CreateFunctionGroupTestIds'

export const createFunctionGroupHelp: HelpFile = {
  docPage: '/docs/governance/function-groups',
  texts: {
    [CreateFunctionGroupTestIds.cardTitleCreateFunctionGroup]:
      'Create a new function group of the locked type. Required attributes are derived from the type\u2019s attribute definitions.',
    [CreateFunctionGroupTestIds.btnCancelCreateFunctionGroup]: null,
    [CreateFunctionGroupTestIds.btnSubmitCreateFunctionGroup]: null,
    [CreateFunctionGroupTestIds.inputFgDescription]: null,
    [CreateFunctionGroupTestIds.selectFgType]: null,
  },
}
